import { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { toast } from "react-toastify";
import fetchAllCoursesWithIdsC from "./List/CourseListByCenter";
import fetchAllTeacherListByCenter from "./List/TeacherListByCenter";
import fetchAllCentersWithIds from "./List/CenterList";
import { FaChalkboardUser } from "react-icons/fa6";
import { MdOutlineTimer } from "react-icons/md";
import { BsBuildings } from "react-icons/bs";
import fetchAllCoursesWithIds from "./List/CourseList";
import fetchAllTeachersWithIds from "./List/TeacherList";
import api from "../config/URL";

function TimeSlot({ selectedCenter }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [centerData, setCenterData] = useState(null);
  const centerLocalId = localStorage.getItem("selectedCenterId");
  const [filters, setFilters] = useState({
    centerId: "",
    startDate: "",
    endDate: "",
  });
  const [headerToolbar, setHeaderToolbar] = useState({
    start: "today,prev,next",
    center: "title",
    end: "customMonth,customWeek,customDay,customAgenda",
  });

  // Process event data for calendar rendering
  const processEventData = (apiData) => {
    const formattedEvents = apiData.map((item) => {
      const startDateTime = `${item.assessmentDate}T${item.time}`;

      return {
        id: item.assessmentId,
        title: item.childName,
        start: startDateTime,
        end: startDateTime,
        extendedProps: {
          assessmentId: item.assessmentId,
          leadId: item.leadId,
          childName: item.childName,
          centerName: item.centerName,
          assessmentDate: item.assessmentDate,
          time: item.time,
        },
      };
    });

    setEvents(formattedEvents);
  };

  // const SearchShedule = async () => {
  //   try {
  //     setLoading(true);

  //     let response;
  //     const queryParams = new URLSearchParams();

  //     for (let key in filters) {
  //       if (filters[key] && !(key === "centerId" && filters[key] === "0")) {
  //         queryParams.append(key, filters[key]);
  //       }
  //     }

  //     if (queryParams.toString()) {
  //       response = await api.get(
  //         `/getAssessmentCalendar?${queryParams.toString()}`
  //       );
  //     } else {
  //       response = await api.get("/getAssessmentCalendar");
  //     }

  //     setData(response.data);
  //     processEventData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const SearchShedule = async () => {
    try {
      // ✅ Prevent invalid search
      if (
        filters.startDate &&
        filters.endDate &&
        new Date(filters.endDate) < new Date(filters.startDate)
      ) {
        toast.warning("Please select a valid date range");
        return;
      }

      setLoading(true);

      const queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value && !(key === "centerId" && value === "0")) {
          queryParams.append(key, value);
        }
      });

      const response = await api.get(
        `/getAssessmentCalendar${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`
      );

      setData(response.data);
      processEventData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load assessment calendar");
    } finally {
      setLoading(false);
    }
  };

  const fetchCenterData = async () => {
    try {
      const centerData = await fetchAllCentersWithIds();
      if (centerLocalId !== null && centerLocalId !== "undefined") {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerLocalId,
        }));
      } else if (centerData !== null && centerData.length > 0) {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerData[0].id,
        }));
      }
      setCenterData(centerData);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchCenterData(); // Fetch center data and subjects

      // Check if local storage has center ID
      if (centerLocalId && centerLocalId !== "undefined") {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerLocalId,
        }));
      } else if (centerData && centerData.length > 0) {
        // Use the first center's ID as the default if no center is in local storage
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerData[0].id,
        }));
      }
    };
    fetchData();
  }, [selectedCenter]);

  useEffect(() => {
    fetchCenterData();
  }, [selectedCenter]);

  useEffect(() => {
    SearchShedule();
  }, [filters]);

  const handleEventClick = (eventClickInfo) => {
    const { id, title, extendedProps } = eventClickInfo.event;

    const selectedEventDetails = {
      id,
      title,
      ...extendedProps,
    };

    setSelectedEvent(selectedEventDetails);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => {
      const updated = { ...prev, [name]: value };

      // ✅ Validate date range
      if (
        updated.startDate &&
        updated.endDate &&
        new Date(updated.endDate) < new Date(updated.startDate)
      ) {
        toast.warning("End date cannot be before start date");
        return prev;
      }

      return updated;
    });
  };

  const clearFilters = async () => {
    setFilters((prev) => ({
      ...prev,
      startDate: "",
      endDate: "",
    }));

    try {
      setLoading(true);

      const queryParams = new URLSearchParams();
      if (filters.centerId && filters.centerId !== "0") {
        queryParams.append("centerId", filters.centerId);
      }

      const response = await api.get(
        `/getAssessmentCalendar${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`
      );

      setData(response.data);
      processEventData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid card my-2 py-2">
      <div className="row mb-3">
        <div className="col-md-2 col-12 mb-2">
          {/* <select
            className="form-select form-select-sm center_list"
            name="centerId"
            style={{ width: "100%" }}
            onChange={handleFilterChange}
            value={filters.centerId}
          >
            <option value="" disabled>
              Select a Center
            </option>
            {centerData?.map((center) => (
              <option key={center.id} value={center.id}>
                {center.centerNames}
              </option>
            ))}
          </select> */}
          <p
            className="mb-0"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            Assessment
          </p>
        </div>

        <div className="col-md-2 col-12 mb-2">
          <input
            type="date"
            className="form-control form-control-sm center_list"
            // style={{ width: "140px" }}
            name="startDate"
            value={filters.startDate}
            onChange={handleFilterChange}
            placeholder="Date"
          />
        </div>
        <div className="col-md-2 col-12 mb-2">
          <input
            type="date"
            className="form-control form-control-sm center_list"
            // style={{ width: "140px" }}
            name="endDate"
            value={filters.endDate}
            onChange={handleFilterChange}
            placeholder="Date"
          />
        </div>

        <div className="col-md-4 col-12 ">
          <button
            type="button"
            className="btn btn-sm btn-border me-2"
            onClick={clearFilters}
          >
            Clear
          </button>

          {/* <button
            type="button"
            className="btn btn-sm text-white"
            style={{
              fontWeight: "600px !important",
              background: "#eb862a",
            }}
            onClick={SearchShedule}
          >
            Search
          </button> */}
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <>
          <div className="calendar">
            <FullCalendar
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
                resourceTimelinePlugin,
              ]}
              initialView="dayGridMonth"
              headerToolbar={headerToolbar}
              height="90vh"
              events={events}
              editable={false}
              selectable={true}
              dayMaxEventRows={2}
              dayMaxEvents={true}
              moreLinkContent={(args) => (
                <span
                  className="p-2 text-white"
                  style={{
                    backgroundColor: "#287f71",
                    borderRadius: "10px !important",
                  }}
                >
                  {args.num}
                </span>
              )}
              buttonText={{
                today: "Today",
              }}
              views={{
                customDay: { type: "timeGridDay", buttonText: "Day" },
                customWeek: { type: "timeGridWeek", buttonText: "Week" },
                customMonth: { type: "dayGridMonth", buttonText: "Month" },
                customAgenda: { type: "listWeek", buttonText: "Agenda" },
              }}
              eventClick={handleEventClick}
              eventContent={(info) => {
                const { childName, centerName, time } =
                  info.event.extendedProps;

                return (
                  <div className="popover-text-wrapper p-2 border-bottom">
                    <div className="p-1 text-wrap">
                      <FaChalkboardUser className="me-1" />
                      Student: {childName}
                    </div>
                    <div className="p-1 text-wrap">
                      <MdOutlineTimer className="me-1" />
                      Time: {time}
                    </div>
                    <div className="p-1 text-wrap">
                      <BsBuildings className="me-1" />
                      Centre: {centerName}
                    </div>
                  </div>
                );
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default TimeSlot;
